(function() {
	'use strict';

	angular.module('quantixApp').controller('RRCRRTrackerController',
			RRCRRTrackerController);

	RRCRRTrackerController.$inject = [ '$scope', '$http', '$window', '$filter',
			'RRCRRService', 'ClientListService', 'ivhTreeviewBfs',
			'ivhTreeviewOptions', 'ivhTreeviewMgr' ];

	function RRCRRTrackerController($scope, $http, $window, $filter,
			RRCRRService, ClientListService, ivhTreeviewBfs,
			ivhTreeviewOptions, ivhTreeviewMgr) {

		var vm = this;
		$scope.clientNamesList = [];
		vm.clientNameModel = [];
		$scope.selecteclientNamesTemp = [];
		vm.rrtoDate = '';

		vm.rrfromdate = '';
		$scope.fromDate = new Date();
		$scope.toDate = new Date();

		$scope.formats = [ 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy',
				'shortDate', 'dd-MMM-yyyy' ];

		$scope.format = $scope.formats[0];
		$scope.requiredFormat = $scope.formats[4];

		$scope.$watch('fromDate', function() {

			if (!$scope.fromDate) {
				return;
			}
			if (!$scope.startMaxDate || $scope.startMaxDate > $scope.fromDate) {
				$scope.endMaxDate = new Date();
			} else {
				$scope.startMaxDate = $scope.fromDate;
			}
			$scope.fromDate = $scope.fromDate;

		});

		$scope.$watch('misReport.toDate', function() {

			if (!$scope.toDate) {
				return;
			}
			if (!$scope.endMaxDate || ($scope.endMaxDate > $scope.fromDate)) {
				// $scope.endMaxDate = $scope.misReport.toDate;
			} else {
				$scope.startMaxDate = $scope.toDate;
			}
			$scope.toDate = $scope.toDate;
		});

		$scope.restFilter = function() {

			var d = new Date();
			d.setMonth(d.getMonth() - 6);
			vm.rrfromdate = d;
			vm.rrtoDate = new Date();
			$scope.fromDate = d;
			$scope.toDate = new Date();
			vm.clientNameModel = [];
			$scope.selecteclientNamesTemp = [];
			$scope.getRRCRRReportDetails();
		}

		// get Client name List for client name filter
		$scope.getClientNameList = function() {

			RRCRRService.getClientListforRRCRR().then(function(data) {
				$scope.clientNamesList = data;
			}, function(errordata) {

			});

		}

		var rrcrrusageTrackerGrid = '';
		var portfoliouserGrid = '';

		$scope.getRRCRRReportDetails = function() {

			$scope.checkErrForRRCRR(vm.rrfromdate, vm.rrtoDate);
			if ($scope.fromDateTrue == true && $scope.toDateTrue == true) {
				$scope.toDateData = vm.rrtoDate;
				$scope.fromDateData = vm.rrfromdate;
			} else {
				$scope.toDateData = '';
				$scope.fromDateData = '';
			}

			if ($scope.fromDateData == undefined) {
				$scope.fromDateData = '';
			}

			if ($scope.toDateData == undefined) {
				$scope.toDateData = '';

			}

			// client name

			if (vm.clientNameModel != undefined) {
				$scope.selecteclientNamesTemp = vm.clientNameModel
						.map(function(element) {
							return "<" + String(element.name) + "<"
						})
			}

			var searchText = '';
			searchText = "{'fromDate' : '" + $scope.fromDateData
					+ "', 'toDate' : '" + $scope.toDateData
					+ "','clientName':'" + $scope.selecteclientNamesTemp + "'}";
			searchText = searchText.replace(/\'/g, "\"");
			searchText = searchText.replace(/\</g, "\'");

			$scope.rrCRRUsageExDataTemp = searchText;
			RRCRRService.getRRCRRReportTrackerInfo(searchText).then(
					function(result) {

						$scope.rrCrrUsageReportGridData = {

							dataProvider : result,
							delegate : $scope

						};

					});

		}

		$scope.rrcrrusageTrackerGridCompletion = function(event) {
			rrcrrusageTrackerGrid = event.target;
			rrcrrusageTrackerGrid.validateNow();
		};

		$scope.exportExcelRRCRRReportUserTracker = function() {

			$http({
				url : 'api/RRCRRUsageTrack/getRRCRRUsageReportExcelExport',
				method : 'POST',
				data : $scope.rrCRRUsageExDataTemp,
				responseType : 'arraybuffer'
			})
					.success(

							function(response) {

								var isIE = false || !!document.documentMode;
								$scope.response = response;
								var blob = new Blob(
										[ response ],
										{
											type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
										});
								if (isIE) {

									window.navigator.msSaveOrOpenBlob(blob,
											'RR CRR Usage Report.xlsx');
								} else {

									var anchor = angular.element('<a/>');
									var blob = new Blob([ response ], {
										type : 'application/vnd.ms-excel'
									})
									var objectUrl = (window.URL || window.webkitURL)
											.createObjectURL(blob);
									anchor.css({
										display : 'none'
									});
									// Make sure it's not visible
									angular.element(document.body).append(
											anchor); // Attach to document
									anchor.attr({
										href : objectUrl,
										target : '_self',

										download : 'RR CRR Usage Report.xlsx'
									})[0].click();

									anchor.remove();

								}

							})

		}

		$scope.checkErrForRRCRR = function(fromDate, toDate) {
			$scope.errMessage = '';
			$scope.fromDateTrue = false;
			$scope.toDateTrue = false;

			var curDate = new Date();
			if (fromDate == undefined || toDate == undefined) {
				alert("Please Enter Valid Date Range");
				$scope.toDateTrue = false;
				$scope.fromDateTrue = false;
			} else if (fromDate != '' && toDate != '') {
				if (new Date(fromDate) > new Date(toDate)) {
					$scope.toDateTrue = false;
					alert("From Date Cannot be Greater to To Date");
					return false;
				} else {
					$scope.toDateTrue = true;
				}
				if (new Date(fromDate) < curDate) {
					/*
					 * $scope.fromDateTrue = false; $scope.errMessage =
					 * 'fromDate should not be before today.'; alert("fromDate
					 * should not be before today."); return false;
					 */
					$scope.fromDateTrue = true;
				} else {
					$scope.fromDateTrue = false;
					$scope.errMessage = 'fromDate should not be before today.';
					alert("FromDate should not be Before today");
					return false;
					// $scope.fromDateTrue = true;
				}
			} else {
				$scope.fromDateTrue = true;
				$scope.toDateTrue = true;
			}
		};

		$scope.popup3 = {
			opened : false
		};
		$scope.popup4 = {
			opened : false
		};
		$scope.open3 = function($event) {
			$scope.popup3.opened = true;
		};
		$scope.open4 = function($event) {
			$scope.popup4.opened = true;
		};

		$scope.getClientNameList();
		$scope.restFilter();

	}

})();
